<script>
export default {
  filters: {
    uppercase: function(string) {
      var splitStr = string.toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        if (
          splitStr[i] !== 'of' &&
          splitStr[i] !== 'the' &&
          splitStr[i] !== 'and'
        ) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
      }
      // Directly return the joined string
      return splitStr.join(' ')
    },
  },
  props: {
    parent: {
      default: undefined,
      type: String,
    },
    current: {
      default: 'Home',
      type: String,
    },
    paging: {
      default: undefined,
      type: Object,
    },
  },
  data() {
    return {
      isMobile: window.app.isMobile,
    }
  },
}
</script>

<template>
  <div>
    <ol v-if="paging && !isMobile" class="breadcrumb mb-3 px-0">
      <li class="breadcrumb-item">
        <router-link to="/">Home</router-link>
      </li>
      <li v-for="(page, index) in paging" :key="index" class="breadcrumb-item">
        <router-link
          v-if="paging[index] && index !== 'slug'"
          :to="`/${parent}/${paging[index].url}`"
        >
          {{ paging[index].text.replace(/-/gi, ' ') | uppercase }}
        </router-link>
        <span v-else>
          {{ paging[index].text.replace(/-/gi, ' ') | uppercase }}
        </span>
      </li>
    </ol>
    <b-dropdown
      v-else
      :text="$t('Home')"
      variant="link"
      :class="$style.mobileBreadcrumbDropdown"
    >
      <div
        v-for="(page, index) in paging"
        :key="index"
        style="display: contents"
      >
        <b-dropdown-item
          v-if="index !== 'slug'"
          :to="`/${parent}/${paging[index].url}`"
        >
          {{ paging[index].text.replace(/-/gi, ' ') | uppercase }}
        </b-dropdown-item>
        <b-dropdown-item v-else :class="$style.activePage">
          {{ paging[index].text.replace(/-/gi, ' ') | uppercase }}
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.mobileBreadcrumbDropdown {
  button {
    color: $dark;
    border: 2px solid rgba(0, 0, 0, 0.25);
    &:focus,
    &:active,
    &:hover,
    &:visited {
      text-decoration: none;
      box-shadow: none;
    }
  }
  ul {
    min-width: 100%;
    padding: 1rem 0;
    border-radius: 0;
    li {
      padding: 0.1rem 0;
      a {
        color: gray;
      }
      &.activePage {
        a {
          color: $primary;
        }
      }
    }
  }
}
</style>
